import { apiClient } from '@/shared/api/http-client';

import { adminUserSchema } from '../model/admin-user.schemas';
import type { AdminUser } from '../model/admin-user.types';

export const adminUserApi = {
    get: async (signal?: AbortSignal): Promise<AdminUser> => {
        // The root guard is the one authority for where an unauthenticated visit goes, so this
        // request opts out of the client's own central redirect.
        const data = await apiClient.get('/auth/me', { signal, skipAuthRedirect: true });
        return adminUserSchema.parse(data);
    },
    // Opts out for the same reason: its 401 branch redirects to Cognito's logout, not back
    // into this app, so the central redirect must not race it.
    signOut: () => apiClient.post('/auth/sign-out', undefined, { skipAuthRedirect: true }),
};
